import { useEffect, useState } from 'react';
import { Snackbar, Button } from '@mui/material';
import { registerServiceWorker } from '../../utilities/registerServiceWorker';

/**
 * Mounts service-worker registration and shows a refresh prompt when a new
 * build is waiting. No-op unless REACT_APP_ENABLE_SW=true in production.
 */
const ServiceWorkerUpdater = () => {
    const [waitingReg, setWaitingReg] = useState(null);

    useEffect(() => {
        registerServiceWorker({
            onUpdate: (registration) => setWaitingReg(registration),
        });
    }, []);

    const refresh = () => {
        if (waitingReg && waitingReg.waiting) {
            waitingReg.waiting.postMessage('SKIP_WAITING');
        }
        window.location.reload();
    };

    return (
        <Snackbar
            open={!!waitingReg}
            message="A new version is available."
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            action={
                <Button color="secondary" size="small" onClick={refresh}>
                    Refresh
                </Button>
            }
        />
    );
};

export default ServiceWorkerUpdater;
